module.exports = __webpack_public_path__ + "img/New LifeChain Image.cbbf90ad.jpg";